import { supabase } from '@/config/supabase'
import type { LeadActivity } from '@/types'

export async function logLeadActivity(
  leadId: string,
  action: LeadActivity['action'],
  details: Record<string, string> = {}
) {
  try {
    await supabase.from('lead_activity_log_cagliari').insert({
      lead_id: leadId,
      action,
      details,
    })
  } catch {
    // Non bloccare il flusso
  }
}
